module.exports = __webpack_public_path__ + "img/behance.2085e06f.svg";